import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover, Button, Overlay } from 'react-bootstrap';
import 'font-awesome/css/font-awesome.min.css';

export default class EditorLink extends Component {
  constructor(props) {
    super(props);
    this.onLinkButtonClick = this.onLinkButtonClick.bind(this);
    this.onUrlChange = this.onUrlChange.bind(this);
    this.togglePopover = this.togglePopover.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.state = {
      url: '',
      show: false,
      selection: null,
    };
  }

  onLinkButtonClick() {
    const { onLinkCreate } = this.props;
    const { url } = this.state;
    onLinkCreate(url);
  }

  onUrlChange(e) {
    this.setState({
      url: e.target.value,
    });
  }

  onKeyDown(e) {
    const { onLinkCreate } = this.props;
    const { url } = this.state;
    if (e.which === 13) {
      e.preventDefault();
      onLinkCreate(url);
    }
  }

  togglePopover(e) {
    e.preventDefault();
    const { editorState } = this.props;
    const { show } = this.state;
    const selection = editorState.getSelection();
    const hasSelection = !selection.isCollapsed();
    if (editorState && hasSelection) {
      this.setState({
        show: !show,
      });
    }
  }


  render() {
    const { container, onLinkRemove } = this.props;
    const { show, url } = this.state;

    return (
      <div className="entry-editor-controls entry-editor-controls-single">
        <div className="entry-editor-styleButton" onClick={this.togglePopover}>
          <img className="fit-parent" src="/assets/img/icons/editor/link.svg" role="presentation" />
        </div>
        <div className="entry-editor-styleButton" onClick={onLinkRemove}>
          <img className="fit-parent" src="/assets/img/icons/editor/unlink.svg" role="presentation" />
        </div>
        <Overlay
          container={container}
          show={show}
          onHide={() => this.setState({ show: false })}
          placement="top"
          target={() => this.linkButton}
          rootClose
        >
          <Popover title="Enter a link" id="link-creator-field">
            <input
              type="url" name="url"
              value={url} onChange={this.onUrlChange}
              onKeyDown={this.onKeyDown}
            />
            <Button type="button" onClick={this.onLinkButtonClick}>Create Link</Button>
          </Popover>
        </Overlay>
      </div>
    );
  }
}

EditorLink.propTypes = {
  container: PropTypes.object,
  onLinkCreate: PropTypes.func,
  onLinkRemove: PropTypes.func,
  editorState: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/cms/form/editor/EditorLink.js